// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pGwF","fullView":"styles_fullView__1wIG_"};